import "./loader.css";
export const Loader: React.FC = () => {
  return (
    <div className="mt-40 flex justify-center items-center flex-col">
      <div className="book">
        <div className="inner">
          <div className="left"></div>
          <div className="middle"></div>
          <div className="right"></div>
        </div>
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
      <h2 className="text-2xl font-bold mt-6">{"Loading..."}</h2>
    </div>
  );
};
